import { createIcon, Path } from './index';

export const IconPlus = createIcon({
  title: 'A plus sign',
  viewBox: '0 0 24 24',
  path: [
    <Path
      d="M12 5V19"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <Path
      d="M5 12H19"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});
